import { type FC, type JSX } from 'react';

import { Tooltip, type TooltipProps } from '@craft/ui/components/tooltips';

export interface NotClearedTooltipProps extends TooltipProps {
  readonly children: JSX.Element;
}

/**
 * @deprecated
 * Please use the Tooltip component directly.
 */
export const NotClearedTooltip: FC<NotClearedTooltipProps> = ({
  children,
  placement = 'top',
  ...props
}) => (
  <Tooltip arrow {...props} placement={placement}>
    <span role='tooltip'>{children}</span>
  </Tooltip>
);
